import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { TabsContext } from './tabs-context';
import TabPanel from './tab-panel';

const Tab = ({ children, id, title, defaultSelected }) => {
  const tabsContext = useContext(TabsContext);
  const { activeTabId } = tabsContext.state;

  useEffect(() => {
    tabsContext.addTab({ id, title });
    if (defaultSelected) {
      tabsContext.selectTab(id);
    }
  }, []);

  return activeTabId === id ? (
    <TabPanel labelledby={id}>{children}</TabPanel>
  ) : null;
};

Tab.defaultProps = {
  defaultSelected: false,
  children: null,
};

Tab.propTypes = {
  defaultSelected: PropTypes.bool,
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Tab;
